import { Mapper } from '../../../../../core/base';
import { LocationGroupWebEntity } from './location-groups-web-entity';
import { LocationGroup } from 'planning-portal-library/src/lib/core/domain/models/location-group';
import { FilterSchemaWebRepositoryMapper } from './filter-schema-mapper';
import { LocationGroupFilterWebEntity } from './location-group-filter-web-entity';
import { LocationGroupFilter } from 'planning-portal-library/src/lib/core/domain/models/location-group-filter';
import { PlanLocationGroup } from 'planning-portal-library/src/lib/core/domain/models/plan-location-group';
import { PlanLocationGroupWebRepositoryMapper } from './plan-location-group-web-repository-mapper';
import { PlanLocationGroupWebEntity } from './plan-location-group-web-entity';
import { MasterPlanLocation } from 'planning-portal-library/src/lib/core/domain';
import {
  MasterPlanLocationWebEntity,
  MasterPlanLocationWebRespositoryMapper,
} from '../../../master-plans/master-plan-web-repository/entities';

export class LocationGroupWebRepositoryMapper extends Mapper<
  LocationGroupWebEntity,
  LocationGroup
> {
  mapFrom(param: LocationGroupWebEntity): LocationGroup {
    const filterSchemaMapper = new FilterSchemaWebRepositoryMapper();
    const filterSchemas: LocationGroupFilter[] = [];
    param.filterSchema?.forEach((filterSchema) => {
      const mappedLocationUpdateEntity = filterSchemaMapper.mapTo(filterSchema);
      filterSchemas.push(mappedLocationUpdateEntity);
    });

    const planLocationGroups: PlanLocationGroup[] = [];
    const planLocationGroupMapper = new PlanLocationGroupWebRepositoryMapper();
    param.planLocationGroups?.forEach((planLocationGroup) => {
      const mappedplanLocationGroupEntity =
        planLocationGroupMapper.mapTo(planLocationGroup);
      planLocationGroups.push(mappedplanLocationGroupEntity);
    });

    const masterPlanLocationMapper =
      new MasterPlanLocationWebRespositoryMapper();
    var locations: MasterPlanLocation[] = [];
    if (param.locations) {
      param.locations.forEach((location) => {
        const mappedLocationEntity = masterPlanLocationMapper.mapFrom(location);
        locations.push(mappedLocationEntity);
      });
    }

    return {
      id: param.id,
      name: param.name,
      locationCount: param.locationCount,
      filterSchema: filterSchemas,
      geometry: JSON.parse(param.geometry),
      color: param.color,
      source: param.source,
      icon: param.icon,
      isChecked: false,
      planContainerId: param.planContainerId,
      planLocationGroups: planLocationGroups,
      locations: locations,
      isAttachedToPlan: param.isAttachedToPlan ?? false,
      additionalData:param.additionalData
    };
  }

  mapTo(param: LocationGroup): LocationGroupWebEntity {
    const filterSchemaMapper = new FilterSchemaWebRepositoryMapper();
    const filterSchemas: LocationGroupFilterWebEntity[] = [];
    param.filterSchema?.forEach((filterSchema) => {
      const mappedfilterSchemaEntity = filterSchemaMapper.mapTo(filterSchema);
      filterSchemas.push(mappedfilterSchemaEntity);
    });

    const planLocationGroups: PlanLocationGroupWebEntity[] = [];
    const planLocationGroupMapper = new PlanLocationGroupWebRepositoryMapper();

    param.planLocationGroups?.forEach((planLocationGroup) => {
      const mappedplanLocationGroupEntity =
        planLocationGroupMapper.mapFrom(planLocationGroup);
      planLocationGroups.push(mappedplanLocationGroupEntity);
    });

    const masterPlanLocationMapper =
      new MasterPlanLocationWebRespositoryMapper();
    var locations: MasterPlanLocationWebEntity[] = [];
    if (param.locations) {
      param.locations.forEach((location) => {
        const mappedLocationEntity = masterPlanLocationMapper.mapTo(location);
        locations.push(mappedLocationEntity);
      });
    }
    return {
      id: param.id,
      name: param.name,
      locationCount: param.locationCount,
      filterSchema: filterSchemas,
      geometry: JSON.stringify(param.geometry),
      source: param.source,
      color: param.color,
      icon: param.icon,
      planLocationGroups: planLocationGroups,
      planContainerId: param.planContainerId,
      locations: locations,
      isAttachedToPlan: param.isAttachedToPlan,
      additionalData:param.additionalData,
    };
  }
}
